var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0FB11F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M16 12l-6 5V7l6 5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlay);
export default __webpack_public_path__ + "static/media/ic_play.7398b36fecb606a676be1dc17371d2a4.svg";
export { ForwardRef as ReactComponent };